import { format } from 'date-fns';
import logo from '~/assets/img/logo/lettermarkOrangeLG.png';

export default function Brand() {
  return (
    <div className="absolute bottom-0 right-4 flex flex-col items-end text-2xs text-primary">
      <img src={logo} width={135} height={23} alt="Civilgrid Logo"></img>
      <div>
        Created on: <span className="font-medium">{format(Date.now(), 'MM-dd-yyyy')}</span>
      </div>
    </div>
  );
}
